import React from 'react';
import { View } from '@react-pdf/renderer'
import { CommonStyles } from '../pdf-styles'

export const Row = ({ children, style = {}, marginBottom = 10 }) => (
  <View style={{ ...CommonStyles.row, marginBottom, ...style }}>{children}</View>
)
